import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'
import {customerDetailsReducer} from "../CustomerDetails/modules/CustomerDetails";

export default (store) => ({
  path: `/state-manager/:typeFilter/:dateFilter`,
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const StateManager = require('./containers/StateManagerContainer').default
      const { stateManagerFilterReducer, walkInInterestLeadsReducer, customerInterestLeadsReducer,walkInInterestFormReducer, selectedValuesReducer,
        setStateTypeReducer, endlessAisleFormReducer } = require('./modules/stateManager')
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'stateManagerFilter', reducer: stateManagerFilterReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'walkInInterestLeads', reducer: walkInInterestLeadsReducer})
      injectReducer(store, {key: 'customerInterestLeads', reducer: customerInterestLeadsReducer})
      injectReducer(store, {key: 'walkInInterestForm', reducer: walkInInterestFormReducer})
      injectReducer(store, {key: 'walkInInterestColumns', reducer: selectedValuesReducer})
      injectReducer(store,{key: 'setStateType',reducer: setStateTypeReducer})
      injectReducer(store, {key: 'endlessAisleInterestForm', reducer: endlessAisleFormReducer})
      injectReducer(store, {key: 'customerDetails', reducer: customerDetailsReducer})

      // injectReducer(store, {key: 'setDialogClose', reducer: setDialogCloseReducer()})

      /*  Return getComponent   */
      cb(null, StateManager)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/StateManager/index.js